<template>
  <div>
    <top-header :type="6" placeholder="云聚楼宇" fontSize="0.32rem" />
    <div class="flex">
      <img class="bg_img" src="@/assets/img/xcx.png" alt="" />
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_3e427591804b"
        path="pages/index/index.html"
        style="position: fixed;bottom: -20px;transform: translateX(-50%);left: 50%;width: 70%;height:180px;z-index: 10;"
      >
        <script type="text/wxtag-template">
          <style>
                .mini-btn {
                  width: 100%;
                  height: 100%;
                  border: none;
                  border-radius: 20px;
                  z-index: 99;
                  background:#3072f5;
                  color:#fff;
                  padding:15px 0;
                }
            </style>
            <button class="mini-btn">立刻进入</button>
        </script>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>
<script>
import topHeader from "@/components/header";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {},
  components: {
    topHeader,
  },
  methods: {},
};
</script>
<style lang="less">
.bg_img {
  width: 100%;
  height: calc(100vh - 0.9rem);
}
.flex {
  display: flex;
  flex-wrap: wrap;

  .module {
    padding: 0.4rem 0;
    margin-top: 0.3rem;
    border-radius: 10px;
    background: #e1eafb;
    width: 42%;
    margin: 4%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .arrow_all {
      width: 1.2rem;
      height: 1.2rem;
    }

    .word {
      font-size: 16px;
    }
  }
}
</style>
